import React from 'react'

// Import from bootstrap
import { Row, Col } from "react-bootstrap";

// Import icon
// import { FaArrowCircleRight, FaArrowCircleLeft } from "react-icons/fa";
import { SiGooglechrome,  SiRiotgames } from "react-icons/si";

const FooterComp = () => {
  return (
    <>
        <footer>
            <div className="footer-text text-white">
              <img src="https://lnr.com.ar/img/logos/logo-light.png" alt="riot-games-logo"/>
              <p>All the images and videos are property of Riot Games&trade;</p>
              <p>Proyecto de personal.</p>
              <Row>
                <Col>
                  {/* <a><FaArrowCircleRight/></a> */}
                </Col>
                <Col>
                <a href='https://playvalorant.com/' target="_blank" rel="noreferrer"><SiRiotgames/></a>
                </Col>
                <Col>
                  <a href='https://lnr.com.ar' target="_blank" rel="noreferrer"><SiGooglechrome/></a>
                </Col>
                <Col>
                  {/* <a><FaArrowCircleLeft/></a> */}
                </Col>
              </Row>
            </div>
        </footer>
    </>
  )
}

export default FooterComp